export const AddGoalInterface = {
    idPerfil: "",
    idMunicipioReportes: "",
    idDF: "",
    Meta: "",
}